import { Table, TableBody, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { Warehouse } from '@/interfaces/warehouse/Warehouse'

import { WarehouseItem, WarehouseStats } from './WarehouseItem'

interface WarehousesProps {
  warehouses: Warehouse[] | undefined
  statsByWarehouseId?: Map<string, WarehouseStats>
  isLoading?: boolean
  onEdit?: (warehouse: Warehouse) => void
  onDelete?: (warehouse: Warehouse) => Promise<void>
}

export const Warehouses = ({ warehouses, statsByWarehouseId, isLoading, onEdit, onDelete }: WarehousesProps) => (
  <div className="overflow-hidden rounded-lg border">
    <Table>
      <TableHeader>
        <TableRow className="hover:bg-transparent">
          <TableHead>Název</TableHead>
          <TableHead className="hidden w-24 md:table-cell">Kód</TableHead>
          <TableHead className="hidden w-24 text-right md:table-cell">Položek</TableHead>
          <TableHead className="w-32 text-right">Skladem</TableHead>
          <TableHead className="hidden w-40 text-right md:table-cell">Dochází</TableHead>
          <TableHead className="hidden w-28 md:table-cell">Stav</TableHead>
          <TableHead className="w-px" />
        </TableRow>
      </TableHeader>
      <TableBody>
        {isLoading && Array.from({ length: 3 }).map((_, index) => <WarehouseItem key={index} />)}
        {!isLoading &&
          warehouses?.map((warehouse) => (
            <WarehouseItem
              key={warehouse.id}
              warehouse={warehouse}
              stats={statsByWarehouseId?.get(warehouse.id)}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          ))}
      </TableBody>
    </Table>
  </div>
)
